import { FC } from 'react';

import { usePageTitleTranslation } from 'libs/navigation';

import { useDirectories } from '../hooks';
import { DirectoriesView } from '../views/DirectoriesView';

export type DirectoriesContainerProps = {};

export const DirectoriesContainer: FC<DirectoriesContainerProps> = () => {
  const { loading, directories } = useDirectories();

  usePageTitleTranslation('directory.directories.title');

  return (
    <DirectoriesView
      directories={directories}
      loading={loading && !directories}
    />
  );
};
